import { render, staticRenderFns } from "./ChartSkeleton.vue?vue&type=template&id=63503bd6&scoped=true"
import script from "./ChartSkeleton.vue?vue&type=script&lang=js"
export * from "./ChartSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChartSkeleton.vue?vue&type=style&index=0&id=63503bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63503bd6",
  null
  
)

export default component.exports